import { createContext, useCallback, useContext, useState } from "react";
import { AlertTriangle } from "lucide-react";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  const confirm = useCallback((message, { title = "تأكيد الإجراء", okLabel = "تأكيد", danger = false } = {}) =>
    new Promise((resolve) => setState({ message, title, okLabel, danger, resolve })), []);
  const close = (v) => { state?.resolve(v); setState(null); };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {state && (
        <div className="modal-backdrop" style={{ zIndex: 200 }} onMouseDown={(e) => e.target === e.currentTarget && close(false)}>
          <div className="modal" style={{ width: "min(420px,100%)", textAlign: "center" }} data-testid="confirm-dialog">
            <span className="ring" style={{ width: 56, height: 56, borderRadius: "50%", display: "grid", placeItems: "center", margin: "0 auto 12px", background: state.danger ? "#FEF2F2" : "var(--primary-soft)", color: state.danger ? "var(--danger)" : "var(--primary)" }}><AlertTriangle size={26} /></span>
            <h2 style={{ paddingInlineEnd: 0 }}>{state.title}</h2>
            <p className="muted" style={{ fontSize: 14, lineHeight: 1.8 }}>{state.message}</p>
            <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 18 }}>
              <button className="btn btn-outline btn-sm" onClick={() => close(false)} data-testid="confirm-cancel">إلغاء</button>
              <button className={`btn btn-sm ${state.danger ? "" : "btn-primary"}`} style={state.danger ? { background: "var(--danger)", color: "#fff" } : {}} onClick={() => close(true)} data-testid="confirm-ok">{state.okLabel}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmContext);
